<div style="box-sizing: border-box; display: flex; flex: 1 1 0%; flex-direction: column; gap: 20px; width: inherit;">
  <div></div>
  <div style="display: flex; flex-direction: row; gap: 20px; width: inherit;">
    <div></div>
    <div style="box-sizing: border-box; display: flex; flex: 1 1 0%; flex-direction: column; width: inherit;">
      <!--User Detail Toolbar-->
      <mat-toolbar color="primary" class="toolbar-over-card">
        <div style="box-sizing: border-box; display: flex; flex: 1 1 0%; place-content: center flex-start; align-items: center;">
          <mat-card-title>User Information</mat-card-title>
        </div>
        <div style="box-sizing: border-box; display: flex; flex: 1 1 0%; place-content: center flex-end; align-items: center; margin-bottom: 8px;">
          <button mat-icon-button matTooltip="More...." [matMenuTriggerFor]="userMenu"><mat-icon>more_vert</mat-icon></button>
          <mat-menu #userMenu="matMenu">
            <button mat-menu-item id="exportUsers" *inRole="[roles.GlobalAccountAdvancedFeatureSet, roles.ProfessionalServices]" (click)="exportUsers()"><mat-icon>file_download</mat-icon> Export to Excel</button>
            <button mat-menu-item id="editUser" *inRole="[roles.GlobalAccountAdvancedFeatureSet, roles.Administrator]" (click)="editUser()"><mat-icon>edit</mat-icon> Edit User Profile</button>
            <button mat-menu-item id="manageOpenAI" *inRole="[roles.GlobalAccountAdvancedFeatureSet, roles.Administrator, roles.ProfessionalServices]" (click)="manageOpenAI()">
              <mat-icon style="font-size:21px; transform: translate(2px, -2px)">
                <div class="far fa-stars"></div>
              </mat-icon> Manage OpenAI Settings</button>
            <button mat-menu-item id="deleteUser" *inRole="[roles.GlobalAccountAdvancedFeatureSet, roles.ProfessionalServices]" (click)="deleteUser()"><mat-icon>delete</mat-icon> Delete User</button>
          </mat-menu>
        </div>
      </mat-toolbar>
      <!--User Detail Content-->
      <div style="width: inherit; flex: 1 1 0%; box-sizing: border-box;">
        <mat-card appearance="outlined" style="width: inherit;">
          <mat-card-content *ngIf="selectedUser && selectedUserProfile" style="width: inherit;">
            <form>
              <div class="row" style="box-sizing: border-box; display: flex; flex: 1 1 0%; gap: 20px; place-content: end space-between; align-items: end; ">
                <div style="flex: 1 1 0%; box-sizing: border-box;">
                  <div>
                    <div>
                      <mat-label class="title">User Guid</mat-label>
                    </div>
                    <div>{{selectedUser.id}}</div>
                  </div>
                </div>
                <div style="flex: 1 1 0%; box-sizing: border-box;">
                  <div>
                    <div>
                      <mat-label class="title">User Name</mat-label>
                    </div>
                    <div>{{selectedUser.userName}}</div>
                  </div>
                </div>
                <div style="flex: 1 1 0%; box-sizing: border-box;">
                  <div>
                    <div>
                      <mat-label class="title">Email</mat-label>
                    </div>
                    <div>{{selectedUser.email || '&lt;Unknown&gt;'}}</div>
                  </div>
                </div>
              </div>
              <div class="row" style="box-sizing: border-box; display: flex; flex: 1 1 0%; gap: 20px; place-content: end space-between; align-items: end; ">
                <div style="flex: 1 1 0%; box-sizing: border-box;">
                  <div>
                    <div>
                      <mat-label class="title">Salutation</mat-label>
                    </div>
                    <div>{{selectedUserProfile.salutation || '&lt;Unknown&gt;'}}</div>
                  </div>
                </div>
                <div style="flex: 1 1 0%; box-sizing: border-box;">
                  <div>
                    <div>
                      <mat-label class="title">Name</mat-label>
                    </div>
                    <div>{{selectedUserProfile.firstName || '&lt;Unknown&gt;'}} {{selectedUserProfile.lastName}}</div>
                  </div>
                </div>
                <div style="flex: 1 1 0%; box-sizing: border-box;">
                  <div>
                    <div>
                      <mat-label class="title">Organization</mat-label>
                    </div>
                    <div>{{selectedUserProfile.organization || '&lt;Unknown&gt;'}}</div>
                  </div>
                </div>
              </div>
              <div class="row" style="box-sizing: border-box; display: flex; flex: 1 1 0%; gap: 20px; place-content: end space-between; align-items: end; ">
                <div style="flex: 1 1 0%; box-sizing: border-box;">
                  <div>
                    <div>
                      <mat-label class="title">Last Activity</mat-label>
                    </div>
                    <div>{{selectedUser.lastActivityDate | date: 'MM/dd/yyyy h:mm a'}}</div>
                  </div>
                </div>
                <div style="flex: 1 1 0%; box-sizing: border-box;">
                  <div>
                    <div>
                      <mat-label class="title">Last Login</mat-label>
                    </div>
                    <div>{{selectedUser.lastLoginDate | date: 'MM/dd/yyyy h:mm a'}}</div>
                  </div>
                </div>
                <div style="flex: 1 1 0%; box-sizing: border-box;">
                  <div>
                    <div>
                      <mat-label class="title">Created Date</mat-label>
                    </div>
                    <div>{{selectedUser.createDate | date: 'MM/dd/yyyy h:mm a'}}</div>
                  </div>
                </div>
              </div>
              <div class="row" style="box-sizing: border-box; display: flex; flex: 1 1 0%; gap: 20px; place-content: end space-between; align-items: end; ">
                <div style="flex: 1 1 100%; box-sizing: border-box; max-width: 32%">
                  <div>
                    <div>
                      <mat-label class="title">Current Case</mat-label>
                    </div>
                    <div>{{selectedUserCurrentCase || '&lt;Unknown&gt;'}}</div>
                  </div>
                </div>
              </div>
              <mat-divider></mat-divider>
              <div class="row" style="place-content: flex-end space-between; align-items: flex-end; flex-direction: row; box-sizing: border-box; display: flex; gap:20px; margin-top: 10px;">
                <div style="box-sizing: border-box; display: flex; flex: 1 1 33%; align-self: flex-start;">
                  <div style="width: 100%;">
                    <div>
                      <mat-label class="title">
                        Accounts
                      </mat-label>
                      <mat-icon class="fa-light fa-pen clickable-icon" id="manageAccountAccess" *inRole="[roles.GlobalAccountAdvancedFeatureSet, roles.Administrator]" style="text-align: right; font-size: 14px; height: 14px; width: 14px; float: right; padding-right:18px" matTooltip="Manage Account Access" (click)="manageAccountAccess()"></mat-icon>
                      <span *ngIf="selectedAccountId">
                        <a [attr.id]="'goToAdminAccounts.'+selectedAccountId" [routerLink]="['/admin/accounts']" [queryParams]="{accountId:selectedAccountId}"> <mat-icon class="fa-light fa-arrow-up-right-from-square" style="text-align: right; font-size: 14px; height: 14px; width: 14px; float: right; padding-right:8px" matTooltip="Go to Admin Accounts"></mat-icon></a>
                      </span>
                    </div>
                    <mat-selection-list class="list" [multiple]="false" style="text-align: left;" (selectionChange)="selectAccountIdChange($event)">
                      <mat-list-option style="font-size:12px;" *ngFor="let account of selectedUser.accounts" [value]="account.accountId" [selected]="account.accountId === selectedAccountId">
                        <span matListItemTitle style="display: flex; align-items: center;">{{account.accountName}}</span>
                      </mat-list-option>
                      <mat-list-item *ngIf="selectedUser.accounts.length === 0" style="font-size:12px;">&lt;No account assigned to this user&gt;</mat-list-item>
                    </mat-selection-list>
                  </div>
                </div>
                <div style="flex: 1 1 100%; box-sizing: border-box; max-width: 33%">
                  <div>
                    <div>
                      <mat-label class="title">Account Roles</mat-label>
                      <span *ngIf="selectedAccountId">
                        <mat-icon class="fa-light fa-pen clickable-icon" id="manageAccountRoles" *inRole="[roles.GlobalAccountAdvancedFeatureSet, roles.Administrator]" style="text-align: right; font-size: 14px; height: 14px; width: 14px; float: right; padding-right:18px" matTooltip="Manage Account Roles" (click)="manageAccountRoles()"></mat-icon>
                      </span>
                    </div>
                    <mat-selection-list class="list readonly-block" style="text-align: left;">
                      <mat-list-option style="font-size:12px" [selected]="selectedAccountRoles.includes(roleGuid.AccountFeatureSet)"><span matListItemTitle style="display: flex; align-items: center;">AccountFeatureSet</span></mat-list-option>
                      <mat-list-option style="font-size:12px" [selected]="selectedAccountRoles.includes(roleGuid.AuditDocFeatureSet)"><span matListItemTitle style="display: flex; align-items: center;">AuditDocFeatureSet</span></mat-list-option>
                      <mat-list-option style="font-size:12px" [selected]="selectedAccountRoles.includes(roleGuid.DeleteDocFeatureSet)"><span matListItemTitle style="display: flex; align-items: center;">DeleteDocFeatureSet</span></mat-list-option>
                      <mat-list-option style="font-size:12px" [selected]="selectedAccountRoles.includes(roleGuid.DocReviewFeatureSet)"><span matListItemTitle style="display: flex; align-items: center;">DocReviewFeatureSet</span></mat-list-option>
                      <mat-list-option style="font-size:12px" [selected]="selectedAccountRoles.includes(roleGuid.EditFeatureSet)"><span matListItemTitle style="display: flex; align-items: center;">EditFeatureSet</span></mat-list-option>
                      <mat-list-option style="font-size:12px" [selected]="selectedAccountRoles.includes(roleGuid.EditMetadataFeatureSet)"><span matListItemTitle style="display: flex; align-items: center;">EditMetadataFeatureSet</span></mat-list-option>
                      <mat-list-option style="font-size:12px" [selected]="selectedAccountRoles.includes(roleGuid.LimitedFeatureSet)"><span matListItemTitle style="display: flex; align-items: center;">LimitedFeatureSet</span></mat-list-option>
                      <mat-list-option style="font-size:12px" [selected]="selectedAccountRoles.includes(roleGuid.ManageCustomDocFieldsFeatureSet)"><span matListItemTitle style="display: flex; align-items: center;">ManageCustomDocFieldsFeatureSet</span></mat-list-option>
                      <mat-list-option style="font-size:12px" [selected]="selectedAccountRoles.includes(roleGuid.PowerUploadFeatureSet)"><span matListItemTitle style="display: flex; align-items: center;">PowerUploadFeatureSet</span></mat-list-option>
                      <mat-list-option style="font-size:12px" [selected]="selectedAccountRoles.includes(roleGuid.PredictiveCodingFeatureSet)"><span matListItemTitle style="display: flex; align-items: center;">PredictiveCodingFeatureSet</span></mat-list-option>
                      <mat-list-option style="font-size:12px" [selected]="selectedAccountRoles.includes(roleGuid.StandardFeatureSet)"><span matListItemTitle style="display: flex; align-items: center;">StandardFeatureSet</span></mat-list-option>
                    </mat-selection-list>
                  </div>
                </div>
                <div style="flex: 1 1 100%; box-sizing: border-box; max-width: 33%">
                  <div>
                    <div>
                      <mat-label class="title">Cases</mat-label>
                      <span *ngIf="selectedAccountId">
                        <mat-icon class="fa-light fa-pen clickable-icon" id="manageCaseAccess" *inRole="[roles.GlobalAccountAdvancedFeatureSet, roles.Administrator]" style="text-align: right; font-size: 14px; height: 14px; width: 14px; float: right; padding-right:18px" matTooltip="Manage Case Access" (click)="manageCaseAccess()"></mat-icon>
                      </span>
                    </div>
                    <mat-nav-list class="list" style="text-align: left;">
                      @for (case of selectedAccountCases; track case) {
                      <a mat-list-item [attr.id]="'goToAdminCases.'+case.caseId" [routerLink]="['/admin/cases']" [queryParams]="{caseId:case.caseId}" style="font-size: 12px; width: fit-content; min-width: 100%;">
                        <span matListItemTitle style="display: flex; align-items: center; height: 100%;">
                          {{case.caseName}}
                          <mat-icon *ngIf="selectedCasesUploadedDoc.includes(case.caseId)" class="fa-light fa-file-arrow-up" matTooltip="User added docs to this case" style="display: inline-flex; padding-left: 20px; text-align: right; font-size:12px; padding-top:10px"></mat-icon>
                        </span>
                      </a>
                      }
                      <div mat-list-item *ngIf="selectedAccountCases.length === 0 && selectedUser.accounts.length > 0" style="display: flex; justify-content: center;;"><span matListItemTitle style="font-size: 12px;">&lt;No case assigned to user for this account&gt;</span></div>
                    </mat-nav-list>
                  </div>
                </div>
              </div>
            </form>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
    <div></div>
  </div>
  <div></div>
</div>